import { SearchListFilters } from '@/types';

const MAIN_PAGE_SIZE = 25;
const FEATURED_PAGE_SIZE = 100;

export const getExpandedFilters = (
  filters: SearchListFilters | undefined | null,
): SearchListFilters | null => {
  if (!filters) return null;

  const mainIndex = filters.currentPageIndex ?? 0;
  const featuredIndex = Math.floor((mainIndex * MAIN_PAGE_SIZE) / FEATURED_PAGE_SIZE);

  const shift = (from?: number | null, to?: number | null): [number | null, number | null] => {
    if (from == null && to == null) return [null, null];
    const f = from ?? 0;
    const t = to ?? f;
    const range = t - f;
    const shiftValue = Math.max(1, Math.round(range * 0.5));
    return [t + 1, t + shiftValue];
  };

  const [spaceFrom, spaceTo] = shift(filters.spaceFrom, filters.spaceTo);
  const [priceFrom, priceTo] = shift(filters.priceFrom, filters.priceTo);
  const [rentPriceFrom, rentPriceTo] = shift(filters.rentPriceFrom, filters.rentPriceTo);
  const [roomNumberFrom, roomNumberTo] = shift(filters.roomNumberFrom, filters.roomNumberTo);

  return {
    countries: filters.countries,
    districts: filters.districts,
    division: filters.division,
    offerType: filters.offerType,
    categories: filters.categories,
    customEquips: [],
    spaceFrom,
    spaceTo,
    priceFrom,
    priceTo,
    rentPriceFrom,
    rentPriceTo,
    roomNumberFrom,
    roomNumberTo,
    currentPageIndex: featuredIndex,
    itemsPerPage: FEATURED_PAGE_SIZE,
  } as SearchListFilters;
};
